import styled from 'styled-components';
import {
    MOBILE_BREAKPOINT,
    SELECTORS,
    TABLET_BREAKPOINT
} from '../../constants';

export const InformationSectionContainer = styled.section`
    ${SELECTORS} & {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: center;
        margin-bottom: 100px;
    }
`;

//Image section
export const InformationSectionImageContainer = styled.div`
    ${SELECTORS} & {
        height: fit-content;
        margin: auto 0 auto 0;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        ${SELECTORS} & {
            width: 100%;
            order: 1;
            img {
                margin: 0 0 0 auto;
                max-width: 100%;
            }
        }
    }
`;

//Text section
export const InformationSectionTextContainer = styled.div`
    ${SELECTORS} & {
        width: 33%;
        margin: 10% 0 auto 5%;
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
    }

    @media (max-width: 1720px) {
        ${SELECTORS} & {
            margin-top: 5%;
        }
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        ${SELECTORS} & {
            width: 90%;
            margin: 25px auto 0 20px;
            width: 90%;
            order: 2;
            justify-content: center;
        }
    }
`;

export const InformationSectionDevicesSvgContainer = styled.div`
    ${SELECTORS} & {
        @media (max-width: ${TABLET_BREAKPOINT}) {
            display: none;
        }
    }
`;

export const InformationSectionTitle = styled.h1`
    ${SELECTORS} & {
        margin: 25px 0;
    }
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        ${SELECTORS} & {
            text-align: center;
        }
    }
`;

export const InformationSectionDescription = styled.p`
    ${SELECTORS} & {
        margin-bottom: 25px;
    }
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        ${SELECTORS} & {
            text-align: center;
        }
    }
`;

export const InformationSectionSubscriptionButtonShell = styled.div`
    ${SELECTORS} & {
        margin-bottom: 25px;
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
        width: 100%;
    }
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        ${SELECTORS} & {
            justify-content: center;
        }
    }
`;

export const InformationSectionSubscriptionButtonContainer = styled.div``;

